import React from "react";
import { Link, To, useLocation, useNavigate } from "react-router";

interface IProps extends React.PropsWithChildren {
    publicationId: string;
    to: To;
}

export const CardContextLink = ({ publicationId, to, children }: IProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Link
            onClick={() => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId } })}
            to={to}
            state={{ previousPathname: location.pathname }}
        >
            {children}
        </Link>
    );
};
